import { z } from 'zod';

import { createMigrationRouteGuard } from '@/utils/route-guards/migration-guard';

export const EQUIPMENT_DETAILS_HOST_ROUTES = ['equipment', 'map', 'process-view'] as const;

export const EQUIPMENT_DETAILS_HOST_ROUTE_IDS = [
  '/$org/$agent/equipment',
  '/$org/$agent/map',
  '/$org/$agent/process-view',
] as const;

export type EquipmentDetailsHostRoute = (typeof EQUIPMENT_DETAILS_HOST_ROUTES)[number];
export type EquipmentDetailsHostRouteId = (typeof EQUIPMENT_DETAILS_HOST_ROUTE_IDS)[number];

export const equipmentDetailsRouteSearchSchema = z.object({
  viewId: z.string().optional(),
  sectionId: z.string().optional(),
  equipmentId: z.string().optional(),
});

export type EquipmentDetailsRouteSearch = z.infer<typeof equipmentDetailsRouteSearchSchema>;

export const isEquipmentDetailsHostRouteId = (
  routeId: string | undefined
): routeId is EquipmentDetailsHostRouteId =>
  EQUIPMENT_DETAILS_HOST_ROUTE_IDS.includes(routeId as EquipmentDetailsHostRouteId);

/** Route beforeLoad: migration guard only. Details state is route search, not Jotai. */
export const equipmentDetailsSupportingRouteBeforeLoad = (routeId: string) => {
  const migrationGuard = createMigrationRouteGuard(routeId);

  return (ctx: Parameters<typeof migrationGuard>[0]) => {
    migrationGuard(ctx);
  };
};

/** Shared route options for pages that host equipment-details deep links. */
export const equipmentDetailsSupportingRouteOptions = (routeId: string) => ({
  beforeLoad: equipmentDetailsSupportingRouteBeforeLoad(routeId),
  validateSearch: equipmentDetailsRouteSearchSchema,
});
